import React from 'react';
import { IconProps } from '.';

const SvgSubscription = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M18.178 6.847h-7.26v1.551h7.26V6.847ZM10.917 10.725h7.261v1.55h-7.26v-1.55Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M7.096 2H22v15.347C22 19.917 19.947 22 17.414 22H5.153v-.004C3.398 21.912 2 20.441 2 18.64V7.847h5.096V2Zm1.528 16.64a3.38 3.38 0 0 1-.52 1.809h9.31c1.688 0 3.057-1.389 3.057-3.102V3.55H8.624V18.64ZM7.096 9.398H3.529v9.242c0 .999.798 1.809 1.783 1.809.985 0 1.784-.81 1.784-1.81V9.399Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgSubscription;
